import { render } from "./basic-layout.vue?vue&type=template&id=4e94e528"
import script from "./basic-layout.vue?vue&type=script&lang=ts"
export * from "./basic-layout.vue?vue&type=script&lang=ts"

import "./basic-layout.vue?vue&type=style&index=0&id=4e94e528&lang=less"
script.render = render

export default script